import { __assign, __asyncValues, __awaiter, __generator, __spreadArray } from "tslib";
import rawAxios from 'axios';
import { debounceRequest, filterUnique, toQueryString } from '../utils/utils';
// 全局变量配置
var _AXIOS_DEFAULTS_ = window._axios_defaults_ || {};
// 内置请求 API 默认参数
var DEFAULTS = {
    withCredentials: true,
    headers: {
        "Accept": "application/json",
        "Content-Type": "application/json",
    },
};
// 内置请求对象实例
export var axios = rawAxios.create(__assign(__assign({}, DEFAULTS), _AXIOS_DEFAULTS_));
// 全局异常处理
var _AXIOS_ERROR_HANDLERS_ = window._axios_error_handlers_ || [];
var ERROR_HANDLERS = __spreadArray(__spreadArray([], _AXIOS_ERROR_HANDLERS_), [
    function (request, response, error) {
        console.error(error);
    }
]);
// 默认拦截器（请求）
// axios.interceptors.request.use((config) => {
//     return config;
// }, error => {
//     return Promise.reject(error);
// });
// 默认拦截器（响应）
var _AXIOS_RESPONSE_HANDLERS_ = window._axios_response_handlers_ || [];
var RESPONSE_HANDLERS = __spreadArray(__spreadArray([], _AXIOS_RESPONSE_HANDLERS_), [
    function (response) {
        // 默认返回 axios 默认包装对象 data 数据
        return response.data;
    }
]);
axios.interceptors.response.use(function (response) {
    return RESPONSE_HANDLERS.reduce(function (prev, f) { return f(prev); }, response);
}, function (error) {
    if (rawAxios.isAxiosError(error)) {
        var request_1 = error.request, response_1 = error.response;
        ERROR_HANDLERS.forEach(function (f) { return f(request_1, response_1, error); });
    }
    return Promise.reject(error);
});
// 老版方法，需要迁移
/**
 * @deprecated use doRawRequest instead
 */
export function requestRaw(url, settings) {
    return doRawRequest(__assign({ url: url }, settings));
}
/**
 * @deprecated use doRequest instead
 */
export function request(url, settings) {
    return doRawRequest(__assign({ url: url }, settings));
}
// 新版方法
// 原生 axios.request 方法
export function doRawRequest(config) {
    return rawAxios.request(config);
}
// 有默认值的 axios.request 方法
export function doRequest(config) {
    return axios.request(config);
}
/**
 * 发送 GET 请求
 * @param endpoint 请求地址
 * @param queryStringMap GET 请求查询参数字典
 * @param config AxiosRequestConfig
 * @example
 * await doGet("http://httpbin.org/get", {foo: 1})
 * Response:
 * { url: "http://httpbin.org/get?foo=1" }
 */
export function doGet(endpoint, queryStringMap, config) {
    return axios.get(endpoint + toQueryString(queryStringMap), config);
}
export function doDelete(endpoint, queryStringMap, config) {
    return axios.delete(endpoint + toQueryString(queryStringMap), config);
}
export function doHead(endpoint, queryStringMap, config) {
    return axios.head(endpoint + toQueryString(queryStringMap), config);
}
export function doOptions(endpoint, queryStringMap, config) {
    return axios.options(endpoint + toQueryString(queryStringMap), config);
}
/**
 * 发送 POST 请求
 * @param endpoint 请求地址
 * @param data post 参数
 * @param config AxiosRequestConfig
 * @example
 * await doPost("http://httpbin.org/post", {foo: 1})
 * Response:
 * {
 *      data: "{"foo":1}",
 *      headers: {Accept: "application/json"},
 *      url: "http://httpbin.org/post"
 * }
 */
export function doPost(endpoint, data, config) {
    return axios.post(endpoint, data, config);
}
export function doPut(endpoint, data, config) {
    return axios.put(endpoint, data, config);
}
export function doPatch(endpoint, data, config) {
    return axios.patch(endpoint, data, config);
}
/**
 * 在一段时间片内合并多个 GET 请求
 */
export var doUniqueGet = debounceRequest(function (queue, event) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, _b, url, _c, _d, _e, e_1_1;
    var e_1, _f;
    return __generator(this, function (_g) {
        switch (_g.label) {
            case 0:
                _g.trys.push([0, 6, 7, 12]);
                _a = __asyncValues(filterUnique(queue));
                _g.label = 1;
            case 1: return [4 /*yield*/, _a.next()];
            case 2:
                if (!(_b = _g.sent(), !_b.done)) return [3 /*break*/, 5];
                url = _b.value;
                _d = (_c = event).emit;
                _e = [url];
                return [4 /*yield*/, doGet(url)];
            case 3:
                _d.apply(_c, _e.concat([_g.sent()]));
                _g.label = 4;
            case 4: return [3 /*break*/, 1];
            case 5: return [3 /*break*/, 12];
            case 6:
                e_1_1 = _g.sent();
                e_1 = { error: e_1_1 };
                return [3 /*break*/, 12];
            case 7:
                _g.trys.push([7, , 10, 11]);
                if (!(_b && !_b.done && (_f = _a.return))) return [3 /*break*/, 9];
                return [4 /*yield*/, _f.call(_a)];
            case 8:
                _g.sent();
                _g.label = 9;
            case 9: return [3 /*break*/, 11];
            case 10:
                if (e_1) throw e_1.error;
                return [7 /*endfinally*/];
            case 11: return [7 /*endfinally*/];
            case 12:
                event.removeAll();
                return [2 /*return*/];
        }
    });
}); });
